export const STAGED = 'STAGED';
export const PROVISIONED = 'PROVISIONED';
export const ACTIVE = 'ACTIVE';
export const RECOVERY = 'RECOVERY';
export const LOCKED_OUT = 'LOCKED_OUT';
export const SUSPENDED = 'SUSPENDED';
export const DEPROVISIONED = 'DEPROVISIONED';
export const DELETED = 'DELETED';
export const PASSWORD_EXPIRED = 'PASSWORD_EXPIRED';
